import axios from 'axios';
import NotificationService from './NotificationService';
import store from 'store';

const searchParams = new URLSearchParams(window.location.search);
const token = (() => {
  const TOKEN_STORAGE_KEY = 'TOKEN';
  const token = searchParams.get('token') || store.get(TOKEN_STORAGE_KEY);
  if (token) {
    store.set(TOKEN_STORAGE_KEY, token);
    return token;
  }
  // eslint-disable-next-line no-console
  console.error(
    `Please provide a token as a query parameter (?token=...) in order to use the application`
  );
})();

export default class HttpService {
  static getAuthorizationToken() {
    return token;
  }

  constructor() {
    this.http = axios.create({
      baseURL: process.env.VUE_APP_API,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  checkError(data) {
    if (data.error) {
      throw new Error(data.message);
    } else {
      return Promise.resolve(data);
    }
  }

  onResponse = (resp, notify = false) => {
    const { data} = resp;
    if (data.error) {
      // eslint-disable-next-line
      console.error('ERROR: ', {
        baseURL: resp.config.baseURL, 
        url: resp.config.url,
        method: resp.config.method, 
        headers: resp.config.headers,
        data
      })
    }
    return this.checkError(data).then(data => {
      if (notify) {
        NotificationService.onSuccess(data.message);
      }
      return data;
    });
  };

  onError(error, notify = true) {
    if (notify) {
      NotificationService.onError(error.message);
    }
    return Promise.reject(error);
  }
}
